// extracted by mini-css-extract-plugin
module.exports = {"root":"LARDBTabs_root__pRHDl"};